<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <div class="t-apply"></div>

                    <div class="msg-view">
                        <div class="text">
                            <p><b>{{ player_data.nickName }}</b>邀你助力天王魔力海镇魔，安神殿之根基。</p>
                            <p>一个账号仅可助力一次，</p>
                            <p>是否接受邀请？</p>
                        </div>
                    </div>            

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    position: relative;
        width: 673px;
        height: 449px;
    background-image: url(~@/assets/images/modal/bg-modal.png);    
}

.t-apply{
        width: 588px;
        height: 53px;
        margin: 0 auto 16px;
        background-image: url(~@/assets/images/modal/title-invite.png); 
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    text-align: center;
    margin: 0 auto 0;
    padding: 40px 24px 0;
    line-height: 1.6;
    color: #5e2f15;

    font-size: 22px;

    b{
        padding: 0 10px;
        color: #be4139;
    }    
}

.notice{
    margin-top: 22px;
    text-align: center;
    color: #be4139;
}

.warn{
    font-size: 22px;
    text-align: center;
    color: #be4139;
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    padding: 0 20px;
    gap: 30px;
}

.u-btn.ok{
        width: 253px;
        height: 81px;
        background-image: url(~@/assets/images/modal/btn-ok.png);  
}

.u-ctrl .u-btn.cancel{
        width: 237px;
        height: 63px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}
</style>

<script>
import { apiShareApply , apiInviteInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码
            score : 0,
            success : false,
            reward_list : [
                {"giftId":"OW78","giftName":"闪光灯","sendNum":"300"},
                {"giftId":"E559","giftName":"十万个人士兵","sendNum":"2"},
                {"giftId":"ON02","giftName":"高级防具珍材包","sendNum":"100"}
            ],
            msg : {
                1009 : '该玩家已有3位好友助力',
            }             
        }
    },
    mounted(){
        this.render();
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },    
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setShare", '');
                    localStorage.setItem('share', '');
                    this.destroyElement();                     
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiShareApply({ code : this.code }).then(
                res => {
                    this.$toast('助力成功，快去参加活动吧！'); 
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.destroyElement();              
                },
                rej => {
                    this.destroyElement();

                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                  

                    //this.$msg_modal({ type : 'bind-error' , text :  this.msg[rej.code] || rej.message}); 
                    this.$toast(this.msg[rej.code] || rej.message)
                  
                },
            );
        },                
    },
}
</script>